export const general_mode = "general";
export const meeting_mode = "meeting";
export const stories_mode = "stories";
